export default __webpack_public_path__ + "static/media/stamurai.3332a0b5.PNG";